<template>
  <div
    class="container row items-center justify-evenly page-py pb-287"
  >
    <div class="section_about full-width column justify-center">
      <h2 class="title">
        {{ $t('aboutUs') }}
      </h2>
      <div class="section__wrp">
        <div
          class="section__item full-width row justify-between items-center content-start"
        >
          <div class="item__info">
            <div class="info__title">
              {{ $t('company') }}
            </div>
            <p class="info__text text-weight-bold">
              {{ $t('aboutDevInfo2') }}
            </p>
            <p class="info__text">
              {{ $t('dreamFlatTeamWorking') }}
            </p>
            <p class="info__text">
              {{ $t('easyMovementAround') }}
            </p>
            <p class="info__text">
              {{ $t('enjoyAppCountUs') }}
            </p>
          </div>
          <div class="info-numb">01</div>
          <img
            class="info__img"
            :src="`${staticUrl}/images/about-vector-info.webp`"
            alt=""
            loading="lazy"
          />
        </div>
        <div
          class="section__item section__item-m full-width row justify-between items-center content-start"
        >
          <div class="info-numb">01</div>
          <img
            class="info__img"
            :src="`${staticUrl}/images/scott-graham-5fNmWej4tAA-unsplash1.webp`"
            alt=""
            loading="lazy"
          />
          <div class="item__info">
            <div class="info__title">
              {{ $t('company') }}
            </div>
            <p class="info__text text-weight-bold">
              {{ $t('missionCompany') }}
            </p>
            <p class="info__text">
              {{ $t('dreamFlatTeamWorking') }}
            </p>
            <p class="info__text">
              {{ $t('easyMovementAround') }}
            </p>
            <p class="info__text">
              {{ $t('enjoyAppCountUs') }}
            </p>
          </div>
        </div>
        <div
          class="section__item full-width row justify-between items-center content-start section-custom-gap"
        >
          <img
            class="info__img"
            :src="`${staticUrl}/images/Frame716.webp`"
            alt=""
            loading="lazy"
          />
          <div class="info-numb info-numb-center">02</div>
          <div class="item__info">
            <div class="info__title">
              {{ $t('app') }}
            </div>
            <p class="info__text text-weight-bold">
              {{ $t('interiorDesignWithoutSkills') }}
            </p>
            <p class="info__text">
              {{ $t('interiorBuilder') }}
            </p>
          </div>
        </div>
        <div
          class="section__item section__item-m full-width row justify-between items-center content-start mt-64"
        >
          <div class="info-numb">02</div>
          <img
            class="info__img"
            :src="`${staticUrl}/images/telegram-cloud-document-2-54407568484980540221.webp`"
            alt=""
            loading="lazy"
          />
          <div class="item__info">
            <div class="info__title">
              {{ $t('app') }}
            </div>
            <p class="info__text text-weight-bold">
              {{ $t('interiorDesignWithoutSkills') }}
            </p>
            <p class="info__text">
              {{ $t('interiorBuilder') }}
            </p>
          </div>
        </div>
        <div
          class="section__item full-width row justify-between items-center content-start section-custom-gap"
        >
          <div class="item__info">
            <div class="info__title">
              {{ $t('appFeatures') }}
            </div>
            <p class="info__text text-weight-bold">
              {{ $t('interiorWithoutHelp') }}
            </p>
            <p class="info__text">
              {{ $t('opportunityArrange3DTour') }}
            </p>
          </div>
          <div class="info-numb">03</div>
          <img
            class="info__img"
            :src="`${staticUrl}/images/Frame1583.webp`"
            alt=""
            loading="lazy"
          />
        </div>
        <div
          class="section__item section__item-m full-width row justify-between items-center content-start mt-64"
        >
          <div class="info-numb">03</div>
          <img
            class="info__img"
            :src="`${staticUrl}/images/telegram-cloud-document-2-54407568484980540231.webp`"
            alt=""
            loading="lazy"
          />
          <div class="item__info">
            <div class="info__title">
              {{ $t('appFeatures') }}
            </div>
            <p class="info__text text-weight-bold">
              {{ $t('interiorWithoutHelp') }}
            </p>
            <p class="info__text">
              {{ $t('opportunityArrange3DTour') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n';
import {useHead, useRuntimeConfig} from '#imports';

const {t} = useI18n();

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

useHead({
  title: `${t(runtimeConfig.public.vueAppTitle)} - ${t('aboutUs')}`,
  meta: [
    {
      name: 'description',
      content: `${t('aboutMetaDesc')}`,
    },
  ],
  charset: 'utf-8',
});
useSeoMeta({
  title: `${t('DreamFlat')} - ${t('aboutUs')}`,
  ogTitle: `${t('DreamFlat')} - ${t('aboutUs')}`,
  description: `${t('aboutMetaDesc')}`,
  ogDescription: `${t('aboutMetaDesc')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<!-- <style lang="scss" scope="this api replaced by slot-scope in 2.5.0+"> -->
<style lang="scss" scoped>
.pb-287 {
  padding-bottom: 287px;
}
.section_about {
  text-align: center;

  .title {
    font-weight: 700;
    font-size: 36px;
    line-height: 120%;
    letter-spacing: 0.03em;
    color: #3d424a;
    margin-top: 0;
  }

  .section-custom-gap {
    margin-top: 64px;
  }

  .item__info {
    text-align: var(--var-text-align-left);
    width: 420px;
    margin-top: 50px;

    .info__title {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.03em;
      color: $primary;
      margin-bottom: 16px;
    }
    .info__text.text-weight-bold {
      color: #3d424a;
    }

    .info__text {
      font-size: 14px;
      line-height: 140%;
      letter-spacing: 0.02em;
      color: #64686e;
      margin: 8px 0;
    }
  }

  .info-numb {
    width: 80px;
    height: 80px;
    background: $primary;
    border-radius: 64px;
    font-weight: 700;
    font-size: 32px;
    letter-spacing: 0.02em;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .info-numb-center {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      height: 940px;
      width: 2px;
      background: $primary;
    }
  }

  .info__img {
    width: 420px;
  }
}

.section__item-m {
  position: relative;
  display: none;
}

@media (max-width: 955px) {
  // .container{
  //   padding-right: 0;
  //   padding-left: 0;
  // }
  .pb-287 {
    padding-top: 0;
    padding-bottom: 43px;
  }
  .section__item {
    display: none;
  }
  .section__item-m {
    display: block;
    // margin-bottom: 90px;
  }
  .info__img {
    // margin-top: 64px;
    max-width: 100% !important;
    width: 100% !important;
  }
  .info-numb {
    padding: 12px;

    position: absolute;
    width: 62.4px !important;
    height: 62.4px !important;
    left: 16px;
    top: -4px;
    background: #4ea6ec;
    border-radius: 0px 0px 32px 32px !important;
  }
  .item__info {
    margin-top: 0 !important;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 28px;
    width: 100% !important;
  }
  .mt-64 {
    margin-top: 64px;
  }
}
</style>
